import { render, staticRenderFns } from "./MStoreSplitter.vue?vue&type=template&id=de7354d0&scoped=true&"
import script from "./MStoreSplitter.vue?vue&type=script&lang=ts&"
export * from "./MStoreSplitter.vue?vue&type=script&lang=ts&"
import style0 from "./MStoreSplitter.vue?vue&type=style&index=0&id=de7354d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7354d0",
  null
  
)

export default component.exports